// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__379ZV","accent":"Logo_accent__1mXMg"};